import {DocsModuleActions} from '../actions/docsActions';

//Описание ADMS каталога
const initialDocsState = {
    description: {},
    props: {},
    load: false
}
export const docs = (state = { ...initialDocsState} , action) => {
    switch (action.type) {
        case DocsModuleActions.LOAD_OK: 
            return {
                ...state,
                ...action.description,
                load: true
            };
        case DocsModuleActions.LOAD_STARTED: 
        case DocsModuleActions.LOAD_ERROR: 
            return {
                ...initialDocsState
            };
        default:
            return state;
    }
}
